import gql from 'graphql-tag';

const ASSET_FRAGMENT = gql`
  fragment BaseAsset on Asset {
    id
    title
    description
    locale
    filename
    src
  }
`;
export default ASSET_FRAGMENT;
